module.exports = __webpack_public_path__ + "static/media/growing_new_farmers_mobile.59cd94af.jpg";